const LOGIN = {
  LOGIN_INITIALIZATION: 'LOGIN_INITIALIZATION',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERORR: 'LOGIN_ERORR',
}
const LOGOUT = {
  LOGOUT_INITIALIZATION: 'LOGOUT_INITIALIZATION',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_ERORR: 'LOGOUT_ERORR',
}

const CHANGE_PASSWORD = {
  CHANGE_PASSWORD_INITIALIZATION: 'CHANGE_PASSWORD_INITIALIZATION',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_ERORR: 'CHANGE_PASSWORD_ERORR',
}

const GET_USER_DETAILS = {
  GET_USER_DETAILS_INITLIZATION: 'GET_USER_DETAILS_INITLIZATION',
  GET_USER_DETAILS_SUCCESS: 'GET_USER_DETAILS_SUCCESS',
  GET_USER_DETAILS_ERORR: 'GET_USER_DETAILS_ERORR',
}

const GET_USERS_LIST = {
  GET_USERS_LIST_INITLIZATION: 'GET_USERS_LIST_INITLIZATION',
  GET_USERS_LIST_SUCCESS: 'GET_USERS_LIST_SUCCESS',
  GET_USERS_LIST_ERORR: 'GET_USERS_LIST_ERORR',
}

const UPDATE_USER_DETAILS = {
  UPDATE_USER_DETAILS_INITIALIZATION: 'UPDATE_USER_DETAILS_INITIALIZATION',
  UPDATE_USER_DETAILS_SUCCESS: 'UPDATE_USER_DETAILS_SUCCESS',
  UPDATE_USER_DETAILS_ERORR: 'UPDATE_USER_DETAILS_ERORR',
}

const UPDATE_USER_EMAIL_DETAILS = {
  UPDATE_USER_EMAIL_DETAILS_INITIALIZATION:
    'UPDATE_USER_EMAIL_DETAILS_INITIALIZATION',
  UPDATE_USER_EMAIL_DETAILS_SUCCESS: 'UPDATE_USER_EMAIL_DETAILS_SUCCESS',
  UPDATE_USER_EMAIL_DETAILS_ERORR: 'UPDATE_USER_EMAIL_DETAILS_ERORR',
}

const VERIFY_USER_EMAIL_DETAILS = {
  VERIFY_USER_EMAIL_DETAILS_INITIALIZATION:
    'VERIFY_USER_EMAIL_DETAILS_INITIALIZATION',
  VERIFY_USER_EMAIL_DETAILS_SUCCESS: 'VERIFY_USER_EMAIL_DETAILS_SUCCESS',
  VERIFY_USER_EMAIL_DETAILS_ERORR: 'VERIFY_USER_EMAIL_DETAILS_ERORR',
}

//ORGANISATION

const GET_ORGANIZATION_ACTION = {
  GET_ORGANIZATION_INITIALIZATION: 'GET_ORGANIZATION_INITIALIZATION',
  GET_ORGANIZATION_SUCCESS: 'GET_ORGANIZATION_SUCCESS',
  GET_ORGANIZATION_FAILED: 'GET_ORGANIZATION_FAILED',
}

const EDIT_ORGANIZATION_ACTION = {
  EDIT_ORGANIZATION_INITIALIZATION: 'EDIT_ORGANIZATION_INITIALIZATION',
  EDIT_ORGANIZATION_SUCCESS: 'EDIT_ORGANIZATION_SUCCESS',
  EDIT_ORGANIZATION_FAILED: 'EDIT_ORGANIZATION_FAILED',
}

const GET_PRIMARY_COUNTRY_LIST_ACTION = {
  GET_PRIMARY_COUNTRY_LIST_INITIALIZATION:
    'GET_PRIMARY_COUNTRY_LIST_INITIALIZATION',
  GET_PRIMARY_COUNTRY_LIST_SUCCESS: 'GET_PRIMARY_COUNTRY_LIST_SUCCESS',
  GET_PRIMARY_COUNTRY_LIST_FAILED: 'GET_PRIMARY_COUNTRY_LIST_FAILED',
}

const GET_PRIMARY_STATE_LIST_ACTION = {
  GET_PRIMARY_STATE_LIST_INITIALIZATION:
    'GET_PRIMARY_STATE_LIST_INITIALIZATION',
  GET_PRIMARY_STATE_LIST_SUCCESS: 'GET_PRIMARY_STATE_LIST_SUCCESS',
  GET_PRIMARY_STATE_LIST_FAILED: 'GET_PRIMARY_STATE_LIST_FAILED',
}

const GET_PRIMARY_CITY_LIST_ACTION = {
  GET_PRIMARY_CITY_LIST_INITIALIZATION: 'GET_PRIMARY_CITY_LIST_INITIALIZATION',
  GET_PRIMARY_CITY_LIST_SUCCESS: 'GET_PRIMARY_CITY_LIST_SUCCESS',
  GET_PRIMARY_CITY_LIST_FAILED: 'GET_PRIMARY_CITY_LIST_FAILED',
}

const GET_ALTERNATE_COUNTRY_LIST_ACTION = {
  GET_ALTERNATE_COUNTRY_LIST_INITIALIZATION:
    'GET_ALTERNATE_COUNTRY_LIST_INITIALIZATION',
  GET_ALTERNATE_COUNTRY_LIST_SUCCESS: 'GET_ALTERNATE_COUNTRY_LIST_SUCCESS',
  GET_ALTERNATE_COUNTRY_LIST_FAILED: 'GET_ALTERNATE_COUNTRY_LIST_FAILED',
}

const GET_ALTERNATE_STATE_LIST_ACTION = {
  GET_ALTERNATE_STATE_LIST_INITIALIZATION:
    'GET_ALTERNATE_STATE_LIST_INITIALIZATION',
  GET_ALTERNATE_STATE_LIST_SUCCESS: 'GET_ALTERNATE_STATE_LIST_SUCCESS',
  GET_ALTERNATE_STATE_LIST_FAILED: 'GET_ALTERNATE_STATE_LIST_FAILED',
}

const GET_ALTERNATE_CITY_LIST_ACTION = {
  GET_ALTERNATE_CITY_LIST_INITIALIZATION:
    'GET_ALTERNATE_CITY_LIST_INITIALIZATION',
  GET_ALTERNATE_CITY_LIST_SUCCESS: 'GET_ALTERNATE_CITY_LIST_SUCCESS',
  GET_ALTERNATE_CITY_LIST_FAILED: 'GET_ALTERNATE_CITY_LIST_FAILED',
}

//BATCH
const BATCH_LIST = {
  BATCH_LIST_INITIALIZATION: 'BATCH_LIST_INITIALIZATION',
  BATCH_LIST_SUCCESS: 'BATCH_LIST_SUCCESS',
  BATCH_LIST_ERORR: 'BATCH_LIST_ERORR',
}

const BATCH_CREATE = {
  BATCH_CREATE_INITIALIZATION: 'BATCH_CREATE_INITIALIZATION',
  BATCH_CREATE_SUCCESS: 'BATCH_CREATE_SUCCESS',
  BATCH_CREATE_ERORR: 'BATCH_CREATE_ERORR',
}

const BATCH_UPDATE = {
  BATCH_UPDATE_INITIALIZATION: 'BATCH_UPDATE_INITIALIZATION',
  BATCH_UPDATE_SUCCESS: 'BATCH_UPDATE_SUCCESS',
  BATCH_UPDATE_ERORR: 'BATCH_UPDATE_ERORR',
}

const BATCH_DETAILS = {
  BATCH_DETAILS_INITIALIZATION: 'BATCH_DETAILS_INITIALIZATION',
  BATCH_DETAILS_SUCCESS: 'BATCH_DETAILS_SUCCESS',
  BATCH_DETAILS_ERORR: 'BATCH_DETAILS_ERORR',
}

const BATCH_DELETE = {
  BATCH_DELETE_INITIALIZATION: 'BATCH_DELETE_INITIALIZATION',
  BATCH_DELETE_SUCCESS: 'BATCH_DELETE_SUCCESS',
  BATCH_DELETE_ERORR: 'BATCH_DELETE_ERORR',
}

const BATCH_EXAMS = {
  GET_BATCH_EXAMS_INITIALIZATION: 'GET_BATCH_EXAMS_INITIALIZATION',
  GET_BATCH_EXAMS_SUCCESS: 'GET_BATCH_EXAMS_SUCCESS',
  GET_BATCH_EXAMS_ERROR: 'GET_BATCH_EXAMS_ERROR',
}

const ADD_EMPLOYEES_TO_BATCH = {
  ADD_EMPLOYEES_TO_BATCH_INITIALIZATION:
    'ADD_EMPLOYEES_TO_BATCH_INITIALIZATION',
  ADD_EMPLOYEES_TO_BATCH_SUCCESS: 'ADD_EMPLOYEES_TO_BATCH_SUCCESS',
  ADD_EMPLOYEES_TO_BATCH_ERROR: 'ADD_EMPLOYEES_TO_BATCH_ERROR',
}

const BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES = {
  BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_INITIALIZATION:
    'BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_INITIALIZATION',
  BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_SUCCESS:
    'BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_SUCCESS',
  BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_ERROR:
    'BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES_ERROR',
}

const BATCH_BULK_UPLOAD_EMPLOYEES = {
  BATCH_BULK_UPLOAD_EMPLOYEES_INITIALIZATION:
    'BATCH_BULK_UPLOAD_EMPLOYEES_INITIALIZATION',
  BATCH_BULK_UPLOAD_EMPLOYEES_SUCCESS: 'BATCH_BULK_UPLOAD_EMPLOYEES_SUCCESS',
  BATCH_BULK_UPLOAD_EMPLOYEES_ERROR: 'BATCH_BULK_UPLOAD_EMPLOYEES_ERROR',
}

const BATCH_MEMBERS = {
  BATCH_MEMBERS_INITIALIZATION: 'BATCH_MEMBERS_INITIALIZATION',
  BATCH_MEMBERS_SUCCESS: 'BATCH_MEMBERS_SUCCESS',
  BATCH_MEMBERS_ERROR: 'BATCH_MEMBERS_ERROR',
}

const SEND_INVITE_TO_JOIN_BATCH = {
  SEND_INVITE_TO_JOIN_BATCH_INITIALIZATION:
    'SEND_INVITE_TO_JOIN_BATCH_INITIALIZATION',
  SEND_INVITE_TO_JOIN_BATCH_SUCCESS: 'SEND_INVITE_TO_JOIN_BATCH_SUCCESS',
  SEND_INVITE_TO_JOIN_BATCH_ERROR: 'SEND_INVITE_TO_JOIN_BATCH_ERROR',
}

const GET_BATCH_RESUMES = {
  GET_BATCH_RESUMES_INITIALIZATION: 'GET_BATCH_RESUMES_INITIALIZATION',
  GET_BATCH_RESUMES_SUCCESS: 'GET_BATCH_RESUMES_SUCCESS',
  GET_BATCH_RESUMES_ERROR: 'GET_BATCH_RESUMES_ERROR',
}
const BATCH_RESULT = {
  BATCH_RESULT_INITIALIZATION: 'BATCH_RESULT_INITIALIZATION',
  BATCH_RESULT_SUCCESS: 'BATCH_RESULT_SUCCESS',
  BATCH_RESULT_ERROR: 'BATCH_RESULT_ERROR',
  BATCH_RESULT_RESET: 'BATCH_RESULT_RESET',
}

//**********  GET SKILLS *************/
const GET_SKILL_SET = {
  GET_SKILL_SET_INITIALIZATION: 'GET_SKILL_SET_INITIALIZATION',
  GET_SKILL_SET_SUCCESS: 'GET_SKILL_SET_SUCCESS',
  GET_SKILL_SET_ERROR: 'GET_SKILL_SET_ERROR',
  GET_SKILL_SET_RESET: 'GET_SKILL_SET_RESET',
}

//**********  GET SKILLS SET LIST *************/
const GET_SKILL_SET_LIST = {
  GET_SKILL_SET_LIST_INITIALIZATION: 'GET_SKILL_SET_LIST_INITIALIZATION',
  GET_SKILL_SET_LIST_SUCCESS: 'GET_SKILL_SET_LIST_SUCCESS',
  GET_SKILL_SET_LIST_ERROR: 'GET_SKILL_SET_LIST_ERROR',
  GET_SKILL_SET_LIST_RESET: 'GET_SKILL_SET_LIST_RESET',
}

//**********  SET SKILLS *************/
const SET_SKILL_SET = {
  SET_SKILL_SET_INITIALIZATION: 'SET_SKILL_SET_INITIALIZATION',
  SET_SKILL_SET_SUCCESS: 'SET_SKILL_SET_SUCCESS',
  SET_SKILL_SET_ERROR: 'SET_SKILL_SET_ERROR',
  SET_SKILL_SET_RESET: 'SET_SKILL_SET_RESET',
}

//**********  PROCESS JS SKILL SET *************/
const PROCESS_JS_SKILL_SET = {
  PROCESS_JS_SKILL_SET_INITIALIZATION: 'PROCESS_JS_SKILL_SET_INITIALIZATION',
  PROCESS_JS_SKILL_SET_SUCCESS: 'PROCESS_JS_SKILL_SET_SUCCESS',
  PROCESS_JS_SKILL_SET_ERROR: 'PROCESS_JS_SKILL_SET_ERROR',
}

//EXAM
const EXAM_LIST = {
  EXAM_LIST_INITLIZATION: 'EXAM_LIST_INITLIZATION',
  EXAM_LIST_SUCCESS: 'EXAM_LIST_SUCCESS',
  EXAM_LIST_ERORR: 'EXAM_LIST_ERORR',
  //**********  ONGOING *************/
  ONGOING_EXAM_LIST_INITLIZATION: 'ONGOING_EXAM_LIST_INITLIZATION',
  ONGOING_EXAM_LIST_SUCCESS: 'ONGOING_EXAM_LIST_SUCCESS',
  ONGOING_EXAM_LIST_FAIL: 'ONGOING_EXAM_LIST_FAIL',
  //**********  COMPLETED *************/
  COMPLETED_EXAM_LIST_INITLIZATION: 'COMPLETED_EXAM_LIST_INITLIZATION',
  COMPLETED_EXAM_LIST_SUCCESS: 'COMPLETED_EXAM_LIST_SUCCESS',
  COMPLETED_EXAM_LIST_FAIL: 'COMPLETED_EXAM_LIST_FAIL',
  //**********  EXAT TAB KEY *************/
  EXAM_TAB_KEY_SUCCESS: 'EXAM_TAB_KEY_SUCCESS',
  //**********  EXAM BY ID *************/
  EXAM_LIST_BY_ID_INITIALIZATION: 'EXAM_LIST_BY_ID_INITIALIZATION',
  EXAM_LIST_BY_ID_SUCCESS: 'EXAM_LIST_BY_ID_SUCCESS',
  EXAM_LIST_BY_ID_ERROR: 'EXAM_LIST_BY_ID_ERROR',
}

const EXAM_CREATE = {
  EXAM_CREATE_INITLIZATION: 'EXAM_CREATE_INITLIZATION',
  EXAM_CREATE_SUCCESS: 'EXAM_CREATE_SUCCESS',
  EXAM_CREATE_ERORR: 'EXAM_CREATE_ERORR',
}

const EXAM_TYPE = {
  EXAM_TYPE_INITLIZATION: 'EXAM_TYPE_INITLIZATION',
  EXAM_TYPE_SUCCESS: 'EXAM_TYPE_SUCCESS',
  EXAM_TYPE_ERORR: 'EXAM_TYPE_ERORR',
}

const UPDATE_EXAM = {
  UPDATE_EXAM_INITLIZATION: 'UPDATE_EXAM_INITLIZATION',
  UPDATE_EXAM_SUCCESS: 'UPDATE_EXAM_SUCCESS',
  UPDATE_EXAM_ERROR: 'UPDATE_EXAM_ERROR',
}

const EXAM_GRADE_LIST = {
  EXAM_GRADE_LIST_INITLIZATION: 'EXAM_GRADE_LIST_INITLIZATION',
  EXAM_GRADE_LIST_SUCCESS: 'EXAM_GRADE_LIST_SUCCESS',
  EXAM_GRADE_LIST_ERORR: 'EXAM_GRADE_LIST_ERORR',
}

const CREATE_AUTOGENERATE_EXAM_QUESTIONS = {
  CREATE_AUTOGENERATE_EXAM_QUESTIONS_INITLIZATION:
    'CREATE_AUTOGENERATE_EXAM_QUESTIONS_INITLIZATION',
  CREATE_AUTOGENERATE_EXAM_QUESTIONS_SUCCESS:
    'CREATE_AUTOGENERATE_EXAM_QUESTIONS_SUCCESS',
  CREATE_AUTOGENERATE_EXAM_QUESTIONS_ERROR:
    'CREATE_AUTOGENERATE_EXAM_QUESTIONS_ERROR',
}

const ASSIGN_EXAM = {
  ASSIGN_EXAM_INITLIZATION: 'ASSIGN_EXAM_INITLIZATION',
  ASSIGN_EXAM_SUCCESS: 'ASSIGN_EXAM_SUCCESS',
  ASSIGN_EXAM_ERROR: 'ASSIGN_EXAM_ERROR',
}

//QUESTION

const QUESTION_LIST = {
  QUESTION_LIST_INITIALIZATION: 'QUESTION_LIST_INITIALIZATION',
  QUESTION_LIST_SUCCESS: 'QUESTION_LIST_SUCCESS',
  QUESTION_LIST_ERORR: 'QUESTION_LIST_ERORR',
}

const QUESTION_CREATE = {
  QUESTION_CREATE_INITIALIZATION: 'QUESTION_CREATE_INITIALIZATION',
  QUESTION_CREATE_SUCCESS: 'QUESTION_CREATE_SUCCESS',
  QUESTION_CREATE_ERORR: 'QUESTION_CREATE_ERORR',
}

const QUESTION_UPDATE = {
  QUESTION_UPDATE_INITIALIZATION: 'QUESTION_UPDATE_INITIALIZATION',
  QUESTION_UPDATE_SUCCESS: 'QUESTION_UPDATE_SUCCESS',
  QUESTION_UPDATE_ERORR: 'QUESTION_UPDATE_ERORR',
}

const QUESTION_DETAILS = {
  QUESTION_DETAILS_INITIALIZATION: 'QUESTION_DETAILS_INITIALIZATION',
  QUESTION_DETAILS_SUCCESS: 'QUESTION_DETAILS_SUCCESS',
  QUESTION_DETAILS_ERORR: 'QUESTION_DETAILS_ERORR',
}

const QUESTION_DELETE = {
  QUESTION_DELETE_INITIALIZATION: 'QUESTION_DELETE_INITIALIZATION',
  QUESTION_DELETE_SUCCESS: 'QUESTION_DELETE_SUCCESS',
  QUESTION_DELETE_ERORR: 'QUESTION_DELETE_ERORR',
}

const QUESTION_BULK_UPLOAD = {
  QUESTION_BULK_UPLOAD_INITIALIZATION: 'QUESTION_BULK_UPLOAD_INITIALIZATION',
  QUESTION_BULK_UPLOAD_SUCCESS: 'QUESTION_BULK_UPLOAD_SUCCESS',
  QUESTION_BULK_UPLOAD_ERORR: 'QUESTION_BULK_UPLOAD_ERORR',

  GET_BULK_UPLOAD_QUESTIONS_INITIALIZATION:
    'GET_BULK_UPLOAD_QUESTIONS_INITIALIZATION',
  GET_BULK_UPLOAD_QUESTIONS_SUCCESS: 'GET_BULK_UPLOAD_QUESTIONS_SUCCESS',
  GET_BULK_UPLOAD_QUESTIONS_ERORR: 'GET_BULK_UPLOAD_QUESTIONS_ERORR',
}

//SUBJECT
const SUBJECT_LIST = {
  SUBJECT_LIST_INITIALIZATION: 'SUBJECT_LIST_INITIALIZATION',
  SUBJECT_LIST_SUCCESS: 'SUBJECT_LIST_SUCCESS',
  SUBJECT_LIST_ERORR: 'SUBJECT_LIST_ERORR',
}

const TOPIC_LIST = {
  TOPIC_LIST_INITIALIZATION: 'TOPIC_LIST_INITIALIZATION',
  TOPIC_LIST_SUCCESS: 'TOPIC_LIST_SUCCESS',
  TOPIC_LIST_ERORR: 'TOPIC_LIST_ERORR',
}

const REASONING_TYPE_LIST = {
  REASONING_TYPE_LIST_INITLIZATION: 'REASONING_TYPE_LIST_INITLIZATION',
  REASONING_TYPE_LIST_SUCCESS: 'REASONING_TYPE_LIST_SUCCESS',
  REASONING_TYPE_LIST_ERORR: 'REASONING_TYPE_LIST_ERORR',
}

//**********  STUDENT DATA *************/
const STUDENT_DATA = {
  STUDENT_DATA_INITIALIZATION: 'STUDENT_DATA_INITIALIZATION',
  STUDENT_DATA_SUCCESS: 'STUDENT_DATA_SUCCESS',
  STUDENT_DATA_ERROR: 'STUDENT_DATA_ERROR',
}

//**********  DASHBOARD DATA *************/
const DASHBOARD_DATA = {
  CANDIDATE_STATS_INITIALIZATION: 'CANDIDATE_STATS_INITIALIZATION',
  CANDIDATE_STATS_SUCCESS: 'CANDIDATE_STATS_SUCCESS',
  CANDIDATE_STATS_ERROR: 'CANDIDATE_STATS_ERROR',
}
const ATTEND_EXAM = {
  SET_ATTEND_EXAM_DATA: 'SET_ATTEND_EXAM_DATA',
}
const START_EXAM = {
  START_EXAM_INITIALIZATION: 'START_EXAM_INITIALIZATION',
  START_EXAM_SUCCESS: 'START_EXAM_SUCCESS',
  START_EXAM_ERROR: 'START_EXAM_ERROR',
}
const UPDATE_QUESTION = {
  SET_QUESTION: 'SET_QUESTION',
}

const SUBMIT_EXAM = {
  SUBMIT_EXAM_INITIALIZATION: 'SUBMIT_EXAM_INITIALIZATION',
  SUBMIT_EXAM_SUCCESS: 'SUBMIT_EXAM_SUCCESS',
  SUBMIT_EXAM_ERROR: 'SUBMIT_EXAM_ERROR',
}

const REPORT_QUESTION_TYPE_GET = {
  REPORT_QUESTION_TYPE_GET_INITIALIZATION:
    'REPORT_QUESTION_TYPE_GET_INITIALIZATION',
  REPORT_QUESTION_TYPE_GET_SUCCESS: 'REPORT_QUESTION_TYPE_GET_SUCCESS',
  REPORT_QUESTION_TYPE_GET_ERROR: 'REPORT_QUESTION_TYPE_GET_ERROR',
}

const REPORT_QUESTION_TYPE_POST = {
  REPORT_QUESTION_TYPE_POST_INITIALIZATION:
    'REPORT_QUESTION_TYPE_POST_INITIALIZATION',
  REPORT_QUESTION_TYPE_POST_SUCCESS: 'REPORT_QUESTION_TYPE_POST_SUCCESS',
  REPORT_QUESTION_TYPE_POST_ERROR: 'REPORT_QUESTION_TYPE_POST_ERROR',
}

const EXTERNAL_CANDIDATE_REGISTRATION = {
  EXTERNAL_CANDIDATE_REGISTRATION_INITIALIZATION:
    'EXTERNAL_CANDIDATE_REGISTRATION_INITIALIZATION',
  EXTERNAL_CANDIDATE_REGISTRATION_SUCCESS:
    'EXTERNAL_CANDIDATE_REGISTRATION_SUCCESS',
  EXTERNAL_CANDIDATE_REGISTRATION_ERROR:
    'EXTERNAL_CANDIDATE_REGISTRATION_ERROR',
}
//********** EXAM REPORT DATA *************/
const EXAM_REPORT_DATA = {
  EXAM_REPORT_DATA_INITIALIZATION: 'EXAM_REPORT_DATA_INITIALIZATION',
  EXAM_REPORT_DATA_SUCCESS: 'EXAM_REPORT_DATA_SUCCESS',
  EXAM_REPORT_DATA_ERROR: 'EXAM_REPORT_DATA_ERROR',
}

const EXAM_REPORT_QUESTIONS = {
  GET_EXAM_REPORT_QUESTIONS_INITIALIZATION:
    'GET_EXAM_REPORT_QUESTIONS_INITIALIZATION',
  GET_EXAM_REPORT_QUESTIONS_SUCCESS: 'GET_EXAM_REPORT_QUESTIONS_SUCCESS',
  GET_EXAM_REPORT_QUESTIONS_ERROR: 'GET_EXAM_REPORT_QUESTIONS_ERROR',
}

const ASSIGN_VIEW_EXAM_REPORT_PERMISSION = {
  GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_INITIALIZATION:
    'GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_INITIALIZATION',
  GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_SUCCESS:
    'GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_SUCCESS',
  GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_ERROR:
    'GET_ASSIGN_VIEW_EXAM_REPORT_PERMISSION_ERROR',
}

const FORGOT_PASSWORD = {
  FORGOT_PASSWORD_INITIALIZATION: 'FORGOT_PASSWORD_INITIALIZATION',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_ERORR: 'FORGOT_PASSWORD_ERORR',
}

const RESET_PASSWORD = {
  RESET_PASSWORD_INITIALIZATION: 'RESET_PASSWORD_INITIALIZATION',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_ERORR: 'RESET_PASSWORD_ERORR',
}
//NOTIFICATION

const NOTIFICATION_LIST = {
  NOTIFICATION_LIST_INITIALIZATION: 'NOTIFICATION_LIST_INITIALIZATION',
  NOTIFICATION_LIST_SUCCESS: 'NOTIFICATION_LIST_SUCCESS',
  NOTIFICATION_LIST_ERORR: 'NOTIFICATION_LIST_ERORR',
}

const NOTIFICATION_DETAILS = {
  NOTIFICATION_DETAILS_INITIALIZATION: 'NOTIFICATION_DETAILS_INITIALIZATION',
  NOTIFICATION_DETAILS_SUCCESS: 'NOTIFICATION_DETAILS_SUCCESS',
  NOTIFICATION_DETAILS_ERORR: 'NOTIFICATION_DETAILS_ERORR',
}

const FETCH_RANDOM_USERNAME_PWD = {
  FETCH_RANDOM_USERNAME_PWD_INITIALIZATION:
    'FETCH_RANDOM_USERNAME_PWD_INITIALIZATION',
  FETCH_RANDOM_USERNAME_PWD_SUCCESS: 'FETCH_RANDOM_USERNAME_PWD_SUCCESS',
  FETCH_RANDOM_USERNAME_PWD_ERROR: 'FETCH_RANDOM_USERNAME_PWD_ERROR',
}

const FETCH_BULK_UPLOAD_DETAILS = {
  FETCH_BULK_UPLOAD_DETAILS_INITIALIZATION:
    'FETCH_BULK_UPLOAD_DETAILS_INITIALIZATION',
  FETCH_BULK_UPLOAD_DETAILS_SUCCESS: 'FETCH_BULK_UPLOAD_DETAILS_SUCCESS',
  FETCH_BULK_UPLOAD_DETAILS_ERROR: 'FETCH_BULK_UPLOAD_DETAILS_ERROR',
  FETCH_BULK_UPLOAD_DETAILS_RESET: 'FETCH_BULK_UPLOAD_DETAILS_RESET',
}

// Employee management

const GET_EMPLOYEE_ACTION = {
  GET_EMPLOYEE_LIST_INITIALIZATION: 'GET_EMPLOYEE_LIST_INITIALIZATION',
  GET_EMPLOYEE_LIST_SUCCESS: 'GET_EMPLOYEE_LIST_SUCCESS',
  GET_EMPLOYEE_LIST_FAILED: 'GET_EMPLOYEE_LIST_FAILED',
}
const ADD_EMPLOYEE_ACTION = {
  ADD_EMPLOYEE_LIST_INITIALIZATION: 'ADD_EMPLOYEE_LIST_INITIALIZATION',
  ADD_EMPLOYEE_LIST_SUCCESS: 'ADD_EMPLOYEE_LIST_SUCCESS',
  ADD_EMPLOYEE_LIST_FAILED: 'ADD_EMPLOYEE_LIST_FAILED',
}
const EDIT_EMPLOYEE_ACTION = {
  EDIT_EMPLOYEE_LIST_INITIALIZATION: 'EDIT_EMPLOYEE_LIST_INITIALIZATION',
  EDIT_EMPLOYEE_LIST_SUCCESS: 'EDIT_EMPLOYEE_LIST_SUCCESS',
  EDIT_EMPLOYEE_LIST_FAILED: 'EDIT_EMPLOYEE_LIST_FAILED',
}
const DELETE_EMPLOYEE_ACTION = {
  DELETE_EMPLOYEE_LIST_INITIALIZATION: 'DELETE_EMPLOYEE_LIST_INITIALIZATION',
  DELETE_EMPLOYEE_LIST_SUCCESS: 'DELETE_EMPLOYEE_LIST_SUCCESS',
  DELETE_EMPLOYEE_LIST_FAILED: 'DELETE_EMPLOYEE_LIST_FAILED',
}

const GET_BRANCH_ACTION = {
  GET_BRANCH_LIST_INITIALIZATION: 'GET_BRANCH_LIST_INITIALIZATION',
  GET_BRANCH_LIST_SUCCESS: 'GET_BRANCH_LIST_SUCCESS',
  GET_BRANCH_LIST_FAILED: 'GET_BRANCH_LIST_FAILED',
}
const GET_DEPARTMENT_ACTION = {
  GET_DEPARTMENT_LIST_INITIALIZATION: 'GET_DEPARTMENT_LIST_INITIALIZATION',
  GET_DEPARTMENT_LIST_SUCCESS: 'GET_DEPARTMENT_LIST_SUCCESS',
  GET_DEPARTMENT_LIST_FAILED: 'GET_DEPARTMENT_LIST_FAILED',
}

const ADD_BULK_EMPLOYEE_ACTION = {
  ADD_BULK_EMPLOYEE_LIST_INITIALIZATION:
    'ADD_BULK_EMPLOYEE_LIST_INITIALIZATION',
  ADD_BULK_EMPLOYEE_LIST_SUCCESS: 'ADD_BULK_EMPLOYEE_LIST_SUCCESS',
  ADD_BULK_EMPLOYEE_LIST_FAILED: 'ADD_BULK_EMPLOYEE_LIST_FAILED',
}
const BRANCH_LIST = {
  BRANCH_LIST_INITIALIZATION: 'BRANCH_LIST_INITIALIZATION',
  BRANCH_LIST_SUCCESS: 'BRANCH_LIST_SUCCESS',
  BRANCH_LIST_ERROR: 'BRANCH_LIST_ERROR',
}

const BRANCH_CREATE = {
  BRANCH_CREATE_INITIALIZATION: 'BRANCH_CREATE_INITIALIZATION',
  BRANCH_CREATE_SUCCESS: 'BRANCH_CREATE_SUCCESS',
  BRANCH_CREATE_ERROR: 'BRANCH_CREATE_ERROR',
}

const BRANCH_UPDATE = {
  BRANCH_UPDATE_INITIALIZATION: 'BRANCH_UPDATE_INITIALIZATION',
  BRANCH_UPDATE_SUCCESS: 'BRANCH_UPDATE_SUCCESS',
  BRANCH_UPDATE_ERROR: 'BRANCH_UPDATE_ERROR',
}

const BRANCH_DETAILS = {
  BRANCH_DETAILS_INITIALIZATION: 'BRANCH_DETAILS_INITIALIZATION',
  BRANCH_DETAILS_SUCCESS: 'BRANCH_DETAILS_SUCCESS',
  BRANCH_DETAILS_ERROR: 'BRANCH_DETAILS_ERROR',
}

const BRANCH_DELETE = {
  BRANCH_DELETE_INITIALIZATION: 'BRANCH_DELETE_INITIALIZATION',
  BRANCH_DELETE_SUCCESS: 'BRANCH_DELETE_SUCCESS',
  BRANCH_DELETE_ERROR: 'BRANCH_DELETE_ERROR',
}

const ADD_EMPLOYEES_TO_BRANCH = {
  ADD_EMPLOYEES_TO_BRANCH_INITIALIZATION:
    'ADD_EMPLOYEES_TO_BRANCH_INITIALIZATION',
  ADD_EMPLOYEES_TO_BRANCH_SUCCESS: 'ADD_EMPLOYEES_TO_BRANCH_SUCCESS',
  ADD_EMPLOYEES_TO_BRANCH_ERROR: 'ADD_EMPLOYEES_TO_BRANCH_ERROR',
}

const BRANCH_MEMBERS = {
  BRANCH_MEMBERS_INITIALIZATION: 'BRANCH_MEMBERS_INITIALIZATION',
  BRANCH_MEMBERS_SUCCESS: 'BRANCH_MEMBERS_SUCCESS',
  BRANCH_MEMBERS_ERROR: 'BRANCH_MEMBERS_ERROR',
}

const QUESTIONNAIRE_UPLOAD = {
  QUESTIONNAIRE_UPLOAD_INITIALIZATION: 'QUESTIONNAIRE_UPLOAD_INITIALIZATION',
  QUESTIONNAIRE_UPLOAD_SUCCESS: 'QUESTIONNAIRE_UPLOAD_SUCCESS',
  QUESTIONNAIRE_UPLOAD_ERROR: 'QUESTIONNAIRE_UPLOAD_ERROR',
}

const UPLOAD_QUESTIONNAIRE_HISTORY = {
  UPLOAD_QUESTIONNAIRE_HISTORY_INITIALIZATION:
    'UPLOAD_QUESTIONNAIRE_HISTORY_INITIALIZATION',
  UPLOAD_QUESTIONNAIRE_HISTORY_SUCCESS: 'UPLOAD_QUESTIONNAIRE_HISTORY_SUCCESS',
  UPLOAD_QUESTIONNAIRE_HISTORY_ERROR: 'UPLOAD_QUESTIONNAIRE_HISTORY_ERROR',
}

const DELETE_UPLOAD_HISTORY = {
  DELETE_UPLOAD_HISTORY_INITIALIZATION: 'DELETE_UPLOAD_HISTORY_INITIALIZATION',
  DELETE_UPLOAD_HISTORY_SUCCESS: 'DELETE_UPLOAD_HISTORY_SUCCESS',
  DELETE_UPLOAD_HISTORY_ERROR: 'DELETE_UPLOAD_HISTORY_ERROR',
}

const QUESTIONNAIRE_LIST = {
  QUESTIONNAIRE_LIST_INITIALIZATION: 'QUESTIONNAIRE_LIST_INITIALIZATION',
  QUESTIONNAIRE_LIST_SUCCESS: 'QUESTIONNAIRE_LIST_SUCCESS',
  QUESTIONNAIRE_LIST_ERROR: 'QUESTIONNAIRE_LIST_ERROR',
}

const REMOVE_MEMBER_FROM_BRANCH = {
  REMOVE_MEMBER_FROM_BRANCH_INITIALIZATION:
    'REMOVE_MEMBER_FROM_BRANCH_INITIALIZATION',
  REMOVE_MEMBER_FROM_BRANCH_SUCCESS: 'REMOVE_MEMBER_FROM_BRANCH_SUCCESS',
  REMOVE_MEMBER_FROM_BRANCH_ERROR: 'REMOVE_MEMBER_FROM_BRANCH_ERROR',
}

const ADD_BULK_EMPLOYEE_HISTORY_ACTION = {
  ADD_BULK_EMPLOYEE_LIST_HISTORY_INITIALIZATION:
    'ADD_BULK_EMPLOYEE_LIST_HISTORY_INITIALIZATION',
  ADD_BULK_EMPLOYEE_LIST_HISTORY_SUCCESS:
    'ADD_BULK_EMPLOYEE_LIST_HISTORY_SUCCESS',
  ADD_BULK_EMPLOYEE_LIST_HISTORY_FAILED:
    'ADD_BULK_EMPLOYEE_LIST_HISTORY_FAILED',
}
const BULK_UPLOAD_BRANCH_MEMBERS = {
  BULK_UPLOAD_BRANCH_MEMBERS_INITIALIZATION:
    'BULK_UPLOAD_BRANCH_MEMBERS_INITIALIZATION',
  BULK_UPLOAD_BRANCH_MEMBERS_SUCCESS: 'BULK_UPLOAD_BRANCH_MEMBERS_SUCCESS',
  BULK_UPLOAD_BRANCH_MEMBERS_ERROR: 'BULK_UPLOAD_BRANCH_MEMBERS_ERROR',
}

// SME dashboard

const GET_EXAM_CREATE_REQUEST_ACTION = {
  GET_EXAM_CREATE_REQUEST_INITIALIZATION:
    'GET_EXAM_CREATE_REQUEST_INITIALIZATION',
  GET_EXAM_CREATE_REQUEST_SUCCESS: 'GET_EXAM_CREATE_REQUEST_SUCCESS',
  GET_EXAM_CREATE_REQUEST_SUCCESS_REQ: 'GET_EXAM_CREATE_REQUEST_SUCCESS_REQ',
  GET_EXAM_CREATE_REQUEST_FAILED: 'GET_EXAM_CREATE_REQUEST_FAILED',
}

const GET_SME_EXAM_LIST_ACTION = {
  GET_SME_EXAM_LIST_INITIALIZATION: 'GET_SME_EXAM_LIST_INITIALIZATION',
  GET_SME_EXAM_LIST_SUCCESS: 'GET_SME_EXAM_LIST_SUCCESS',
  GET_SME_EXAM_LIST_FAILED: 'GET_SME_EXAM_LIST_FAILED',
}

const GET_EXAM_CREATE_REQUEST_COUNT_ACTION = {
  GET_EXAM_CREATE_REQUEST_COUNT_INITIALIZATION:
    'GET_EXAM_CREATE_REQUEST_COUNT_INITIALIZATION',
  GET_EXAM_CREATE_REQUEST_COUNT_SUCCESS:
    'GET_EXAM_CREATE_REQUEST_COUNT_SUCCESS',
  GET_EXAM_CREATE_REQUEST_COUNT_FAILED: 'GET_EXAM_CREATE_REQUEST_COUNT_FAILED',
}

const GET_SME_EXAM_PERFORMANCE_ACTION = {
  GET_SME_EXAM_PERFORMANCE_INITIALIZATION:
    'GET_SME_EXAM_PERFORMANCE_INITIALIZATION',
  GET_SME_EXAM_PERFORMANCE_SUCCESS: 'GET_SME_EXAM_PERFORMANCE_SUCCESS',
  GET_SME_EXAM_PERFORMANCE_FAILED: 'GET_SME_EXAM_PERFORMANCE_FAILED',
}

const QUESTIONNAIRE_DETAILS = {
  QUESTIONNAIRE_DETAILS_INITIALIZATION: 'QUESTIONNAIRE_DETAILS_INITIALIZATION',
  QUESTIONNAIRE_DETAILS_SUCCESS: 'QUESTIONNAIRE_DETAILS_SUCCESS',
  QUESTIONNAIRE_DETAILS_ERROR: 'QUESTIONNAIRE_DETAILS_ERROR',
}

const QUESTIONNAIRE_DELETE = {
  QUESTIONNAIRE_DELETE_INITIALIZATION: 'QUESTIONNAIRE_DELETE_INITIALIZATION',
  QUESTIONNAIRE_DELETE_SUCCESS: 'QUESTIONNAIRE_DELETE_SUCCESS',
  QUESTIONNAIRE_DELETE_ERROR: 'QUESTIONNAIRE_DELETE_ERROR',
}

const GET_EXAM_CREATION_DETAILS = {
  GET_EXAM_CREATION_DETAILS_INITIALIZATION:
    'GET_EXAM_CREATION_DETAILS_INITIALIZATION',
  GET_EXAM_CREATION_DETAILS_SUCCESS: 'GET_EXAM_CREATION_DETAILS_SUCCESS',
  GET_EXAM_CREATION_DETAILS_ERROR: 'GET_EXAM_CREATION_DETAILS_ERROR',
}

const SME_CREATE_EXAM_QP = {
  SME_CREATE_EXAM_QP_INITIALIZATION: 'SME_CREATE_EXAM_QP_INITIALIZATION',
  SME_CREATE_EXAM_QP_SUCCESS: 'SME_CREATE_EXAM_QP_SUCCESS',
  SME_CREATE_EXAM_QP_ERROR: 'SME_CREATE_EXAM_QP_ERROR',
}

const GET_ALL_EXAM_CREATE_REQUEST_ACTION = {
  GET_ALL_EXAM_CREATE_REQUEST_INITIALIZATION:
    'GET_ALL_EXAM_CREATE_REQUEST_INITIALIZATION',
  GET_ALL_EXAM_CREATE_REQUEST_SUCCESS: 'GET_ALL_EXAM_CREATE_REQUEST_SUCCESS',
  GET_ALL_EXAM_CREATE_REQUEST_FAILED: 'GET_ALL_EXAM_CREATE_REQUEST_FAILED',
}

// Corporate admin dashboard

const GET_CORPORATE_BRANCH_TOTAL_DETAILS_ACTION = {
  GET_CORPORATE_BRANCH_TOTAL_DETAILS_INITIALIZATION:
    'GET_CORPORATE_BRANCH_TOTAL_DETAILS_INITIALIZATION',
  GET_CORPORATE_BRANCH_TOTAL_DETAILS_SUCCESS:
    'GET_CORPORATE_BRANCH_TOTAL_DETAILS_SUCCESS',
  GET_CORPORATE_BRANCH_TOTAL_DETAILS_FAILED:
    'GET_CORPORATE_BRANCH_TOTAL_DETAILS_FAILED',
}

const GET_CORPORATE_BRANCH_PERFORMANCE_ACTION = {
  GET_CORPORATE_BRANCH_PERFORMANCE_INITIALIZATION:
    'GET_CORPORATE_BRANCH_PERFORMANCE_INITIALIZATION',
  GET_CORPORATE_BRANCH_PERFORMANCE_SUCCESS:
    'GET_CORPORATE_BRANCH_PERFORMANCE_SUCCESS',
  GET_CORPORATE_BRANCH_PERFORMANCE_FAILED:
    'GET_CORPORATE_BRANCH_PERFORMANCE_FAILED',
}

const GET_CORPORATE_BRANCH_EXPENDITURE_ACTION = {
  GET_CORPORATE_BRANCH_EXPENDITURE_INITIALIZATION:
    'GET_CORPORATE_BRANCH_EXPENDITURE_INITIALIZATION',
  GET_CORPORATE_BRANCH_EXPENDITURE_SUCCESS:
    'GET_CORPORATE_BRANCH_EXPENDITURE_SUCCESS',
  GET_CORPORATE_BRANCH_EXPENDITURE_FAILED:
    'GET_CORPORATE_BRANCH_EXPENDITURE_FAILED',
}

// Register candidate
const REGISTER_CANDIDATE_ACTION = {
  REGISTER_CANDIDATE_INITIALIZATION: 'REGISTER_CANDIDATE_INITIALIZATION',
  REGISTER_CANDIDATE_SUCCESS: 'REGISTER_CANDIDATE_SUCCESS',
  REGISTER_CANDIDATE_FAILED: 'REGISTER_CANDIDATE_FAILED',
}

const GET_JOB_ROLE = {
  GET_JOB_ROLE_INITIALIZATION: 'GET_JOB_ROLE_INITIALIZATION',
  GET_JOB_ROLE_SUCCESS: 'GET_JOB_ROLE_SUCCESS',
  GET_JOB_ROLE_FAILED: 'GET_JOB_ROLE_FAILED',
}

const CREATE_JOB_ROLE = {
  CREATE_JOB_ROLE_INITIALIZATION: 'CREATE_JOB_ROLE_INITIALIZATION',
  CREATE_JOB_ROLE_SUCCESS: 'CREATE_JOB_ROLE_SUCCESS',
  CREATE_JOB_ROLE_FAILED: 'CREATE_JOB_ROLE_FAILED',
}

const GET_JOB_ROLE_DETAILS = {
  GET_JOB_ROLE_DETAILS_INITIALIZATION: 'GET_JOB_ROLE_DETAILS_INITIALIZATION',
  GET_JOB_ROLE_DETAILS_SUCCESS: 'GET_JOB_ROLE_DETAILS_SUCCESS',
  GET_JOB_ROLE_DETAILS_FAILED: 'GET_JOB_ROLE_DETAILS_FAILED',
}

const EDIT_JOB_ROLE = {
  EDIT_JOB_ROLE_INITIALIZATION: 'EDIT_JOB_ROLE_INITIALIZATION',
  EDIT_JOB_ROLE_SUCCESS: 'EDIT_JOB_ROLE_SUCCESS',
  EDIT_JOB_ROLE_FAILED: 'EDIT_JOB_ROLE_FAILED',
}

const DELETE_JOB_ROLE = {
  DELETE_JOB_ROLE_INITIALIZATION: 'DELETE_JOB_ROLE_INITIALIZATION',
  DELETE_JOB_ROLE_SUCCESS: 'DELETE_JOB_ROLE_SUCCESS',
  DELETE_JOB_ROLE_FAILED: 'DELETE_JOB_ROLE_FAILED',
}

const GET_JOB_ROLE_SUBMITTED_CANDIDATE_LIST = {
  JOB_ROLE_SUBMITTED_CANDIDATE_LIST_INITIALIZATION:
    'JOB_ROLE_SUBMITTED_CANDIDATE_LIST_INITIALIZATION',
  JOB_ROLE_SUBMITTED_CANDIDATE_LIST_SUCCESS:
    'JOB_ROLE_SUBMITTED_CANDIDATE_LIST_SUCCESS',
  JOB_ROLE_SUBMITTED_CANDIDATE_LIST_FAILED:
    'JOB_ROLE_SUBMITTED_CANDIDATE_LIST_FAILED',
}

const UPDATE_JOB_ROLE_DEACTIVATION_SETTING = {
  UPDATE_JOB_ROLE_DEACTIVATION_SETTING_INITIALIZATION:
    'UPDATE_JOB_ROLE_DEACTIVATION_SETTING_INITIALIZATION',
  UPDATE_JOB_ROLE_DEACTIVATION_SETTING_SUCCESS:
    'UPDATE_JOB_ROLE_DEACTIVATION_SETTING_SUCCESS',
  UPDATE_JOB_ROLE_DEACTIVATION_SETTING_FAILED:
    'UPDATE_JOB_ROLE_DEACTIVATION_SETTING_FAILED',
}

const UPLOAD_BATCH_RESUME = {
  UPLOAD_BATCH_RESUME_INITIALIZATION: 'UPLOAD_BATCH_RESUME_INITIALIZATION',
  UPLOAD_BATCH_RESUME_SUCCESS: 'UPLOAD_BATCH_RESUME_SUCCESS',
  UPLOAD_BATCH_RESUME_FAILED: 'UPLOAD_BATCH_RESUME_FAILED',
}

// Proctoring
const GET_USER_MOVEMENT_IMAGES_ACTION = {
  USER_MOVEMENT_IMAGES_INITIALIZATION: 'USER_MOVEMENT_IMAGES_INITIALIZATION',
  USER_MOVEMENT_IMAGES_SUCCESS: 'USER_MOVEMENT_IMAGES_SUCCESS',
  USER_MOVEMENT_IMAGES_FAILED: 'USER_MOVEMENT_IMAGES_FAILED',
}

const GET_USER_MOVEMENT_IMAGES_ZIP_ACTION = {
  USER_MOVEMENT_IMAGES_ZIP_INITIALIZATION:
    'USER_MOVEMENT_IMAGES_ZIP_INITIALIZATION',
  USER_MOVEMENT_IMAGES_ZIP_SUCCESS: 'USER_MOVEMENT_IMAGES_ZIP_SUCCESS',
  USER_MOVEMENT_IMAGES_ZIP_FAILED: 'USER_MOVEMENT_IMAGES_ZIP_FAILED',
}
// save question status
const SAVE_QUESTION_STATUS = {
  SAVE_QUESTION_SUCCESS: 'SAVE_QUESTION_SUCCESS',
}

//**********  STUDENT DATA DOWNLOAD EXCEL *************/
const STUDENT_DATA_DOWNLOAD_EXCEL = {
  STUDENT_DATA_DOWNLOAD_EXCEL_INITIALIZATION:
    'STUDENT_DATA_DOWNLOAD_EXCEL_INITIALIZATION',
  STUDENT_DATA_DOWNLOAD_EXCEL_SUCCESS: 'STUDENT_DATA_DOWNLOAD_EXCEL_SUCCESS',
  STUDENT_DATA_DOWNLOAD_EXCEL_ERROR: 'STUDENT_DATA_DOWNLOAD_EXCEL_ERROR',
}

const STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL = {
  STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_INITIALIZATION:
    'STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_INITIALIZATION',
  STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_SUCCESS:
    'STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_SUCCESS',
  STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_ERROR:
    'STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL_ERROR',
}

const GET_QUALIFICATION = {
  GET_QUALIFICATION_INITIALIZATION: 'GET_QUALIFICATION_INITIALIZATION',
  GET_QUALIFICATION_SUCCESS: 'GET_QUALIFICATION_SUCCESS',
  GET_QUALIFICATION_FAILED: 'GET_QUALIFICATION_FAILED',
}

const GET_RESUME_DATA = {
  GET_RESUME_DATA_INITIALIZATION: 'GET_RESUME_DATA_INITIALIZATION',
  GET_RESUME_DATA_SUCCESS: 'GET_RESUME_DATA_SUCCESS',
  GET_RESUME_DATA_FAILED: 'GET_RESUME_DATA_FAILED',
}

const GET_RESUME_LINK = {
  GET_RESUME_LINK_INITIALIZATION: 'GET_RESUME_LINK_INITIALIZATION',
  GET_RESUME_LINK_SUCCESS: 'GET_RESUME_LINK_SUCCESS',
  GET_RESUME_LINK_FAILED: 'GET_RESUME_LINK_FAILED',
}

const GET_EXTERNAL_CANDIDATE = {
  GET_EXTERNAL_CANDIDATE_INITIALIZATION:
    'GET_EXTERNAL_CANDIDATE_INITIALIZATION',
  GET_EXTERNAL_CANDIDATE_SUCCESS: 'GET_EXTERNAL_CANDIDATE_SUCCESS',
  GET_EXTERNAL_CANDIDATE_FAILED: 'GET_EXTERNAL_CANDIDATE_FAILED',
}
const UPDATE_BATCH_CANDIDATE = {
  UPDATE_BATCH_CANDIDATE_INITIALIZATION:
    'UPDATE_BATCH_CANDIDATE_INITIALIZATION',
  UPDATE_BATCH_CANDIDATE_SUCCESS: 'UPDATE_BATCH_CANDIDATE_SUCCESS',
  UPDATE_BATCH_CANDIDATE_FAILED: 'UPDATE_BATCH_CANDIDATE_FAILED',
}

const GET_QUESTION_PAPER = {
  GET_QUESTION_PAPER_INITIALIZATION: 'GET_QUESTION_PAPER_INITIALIZATION',
  GET_QUESTION_PAPER_SUCCESS: 'GET_QUESTION_PAPER_SUCCESS',
  GET_QUESTION_PAPER_FAILED: 'GET_QUESTION_PAPER_FAILED',
}

const GET_EXAM_QUESTION = {
  GET_EXAM_QUESTION_INITIALIZATION: 'GET_EXAM_QUESTION_INITIALIZATION',
  GET_EXAM_QUESTION_SUCCESS: 'GET_EXAM_QUESTION_SUCCESS',
  GET_EXAM_QUESTION_FAILED: 'GET_EXAM_QUESTION_FAILED',
}

const GET_EXAM_BATCH = {
  GET_EXAM_BATCH_INITIALIZATION: 'GET_EXAM_BATCH_INITIALIZATION',
  GET_EXAM_BATCH_SUCCESS: 'GET_EXAM_BATCH_SUCCESS',
  GET_EXAM_BATCH_FAILED: 'GET_EXAM_BATCH_FAILED',
}

const GET_BATCH_INVITATION = {
  GET_BATCH_INVITATION_INITIALIZATION: 'GET_BATCH_INVITATION_INITIALIZATION',
  GET_BATCH_INVITATION_SUCCESS: 'GET_BATCH_INVITATION_SUCCESS',
  GET_BATCH_INVITATION_FAILED: 'GET_BATCH_INVITATION_FAILED',
}

const ACCEPT_BATCH_INVITATION = {
  ACCEPT_BATCH_INVITATION_INITIALIZATION:
    'ACCEPT_BATCH_INVITATION_INITIALIZATION',
  ACCEPT_BATCH_INVITATION_SUCCESS: 'ACCEPT_BATCH_INVITATION_SUCCESS',
  ACCEPT_BATCH_INVITATION_FAILED: 'ACCEPT_BATCH_INVITATION_FAILED',
}

const RESET_STUDENT_DOWNLOAD_REPORT = 'RESET_STUDENT_DOWNLOAD_REPORT'

const EXAM_TYPE_WISE_SUBJECT_LIST = {
  EXAM_TYPE_WISE_SUBJECT_LIST_INITIALIZATION:
    'EXAM_TYPE_WISE_SUBJECT_LIST_INITIALIZATION',
  EXAM_TYPE_WISE_SUBJECT_LIST_SUCCESS: 'EXAM_TYPE_WISE_SUBJECT_LIST_SUCCESS',
  EXAM_TYPE_WISE_SUBJECT_LIST_ERORR: 'EXAM_TYPE_WISE_SUBJECT_LIST_ERORR',
}

const SUBJECT_WISE_TOPIC_LIST = {
  SUBJECT_WISE_TOPIC_LIST_INITIALIZATION:
    'SUBJECT_WISE_TOPIC_LIST_INITIALIZATION',
  SUBJECT_WISE_TOPIC_LIST_SUCCESS: 'SUBJECT_WISE_TOPIC_LIST_SUCCESS',
  SUBJECT_WISE_TOPIC_LIST_ERORR: 'SUBJECT_WISE_TOPIC_LIST_ERORR',
}
const RESUME_LIBRARY = {
  RESUME_LIBRARY_LIST_INITIALIZATION: 'RESUME_LIBRARY_LIST_INITIALIZATION',
  RESUME_LIBRARY_LIST_SUCCESS: 'RESUME_LIBRARY_LIST_SUCCESS',
  RESUME_LIBRARY_LIST_ERROR: 'RESUME_LIBRARY_LIST_ERROR',
}
const RESUME_LIBRARY_DETAIL = {
  RESUME_LIBRARY_DETAIL_INITIALIZATION: 'RESUME_LIBRARY_DETAIL_INITIALIZATION',
  RESUME_LIBRARY_DETAIL_SUCCESS: 'RESUME_LIBRARY_DETAIL_SUCCESS',
  RESUME_LIBRARY_DETAIL_ERROR: 'RESUME_LIBRARY_DETAIL_ERROR',
}
const RESUME_LIBRARY_ASSIGN_HISTORY = {
  RESUME_LIBRARY_ASSIGN_HISTORY_INITIALIZATION:
    'RESUME_LIBRARY_ASSIGN_HISTORY_INITIALIZATION',
  RESUME_LIBRARY_ASSIGN_HISTORY_SUCCESS:
    'RESUME_LIBRARY_ASSIGN_HISTORY_SUCCESS',
  RESUME_LIBRARY_ASSIGN_HISTORY_ERROR: 'RESUME_LIBRARY_ASSIGN_HISTORY_ERROR',
}
const RESUME_ACTIVITY = {
  RESUME_ACTIVITY_INITIALIZATION: 'RESUME_ACTIVITY_INITIALIZATION',
  RESUME_ACTIVITY_SUCCESS: 'RESUME_ACTIVITY_SUCCESS',
  RESUME_ACTIVITY_ERROR: 'RESUME_ACTIVITY_ERROR',
}

const GET_RESUME_FILE = {
  GET_RESUME_FILE_INITIALIZATION: 'GET_RESUME_FILE_INITIALIZATION',
  GET_RESUME_FILE_SUCCESS: 'GET_RESUME_FILE_SUCCESS',
  GET_RESUME_FILE_ERROR: 'GET_RESUME_FILE_ERROR',
}
const GET_ASSIGN_BATCH_LIST = {
  GET_ASSIGN_BATCH_LIST_INITIALIZATION: 'GET_ASSIGN_BATCH_LIST_INITIALIZATION',
  GET_ASSIGN_BATCH_LIST_SUCCESS: 'GET_ASSIGN_BATCH_LIST_SUCCESS',
  GET_ASSIGN_BATCH_LIST_ERROR: 'GET_ASSIGN_BATCH_LIST_ERROR',
}
const GET_ASSIGN_TO_BATCH_SKILL_MATCH = {
  GET_ASSIGN_TO_BATCH_SKILL_MATCH_INITIALIZATION:
    'GET_ASSIGN_TO_BATCH_SKILL_MATCH_INITIALIZATION',
  GET_ASSIGN_TO_BATCH_SKILL_MATCH_SUCCESS:
    'GET_ASSIGN_TO_BATCH_SKILL_MATCH_SUCCESS',
  GET_ASSIGN_TO_BATCH_SKILL_MATCH_ERROR:
    'GET_ASSIGN_TO_BATCH_SKILL_MATCH_ERROR',
}

const RESUME_BULK_DELETE = {
  RESUME_BULK_DELETE_INITIALIZATION: 'RESUME_BULK_DELETE_INITIALIZATION',
  RESUME_BULK_DELETE_SUCCESS: 'RESUME_BULK_DELETE_SUCCESS',
  RESUME_BULK_DELETE_ERROR: 'RESUME_BULK_DELETE_ERROR',
}
const RESUME_BULK_BOOKMARK = {
  RESUME_BULK_BOOKMARK_INITIALIZATION: 'RESUME_BULK_BOOKMARK_INITIALIZATION',
  RESUME_BULK_BOOKMARK_SUCCESS: 'RESUME_BULK_BOOKMARK_SUCCESS',
  RESUME_BULK_BOOKMARK_ERROR: 'RESUME_BULK_BOOKMARK_ERROR',
}
const GET_JD_LIST = {
  GET_JD_LIST_INITIALIZATION: 'GET_JD_LIST_INITIALIZATION',
  GET_JD_LIST_SUCCESS: 'GET_JD_LIST_SUCCESS',
  GET_JD_LIST_ERROR: 'GET_JD_LIST_ERROR',
}
const GET_JD_DETAILS = {
  GET_JD_DETAILS_INITIALIZATION: 'GET_JD_DETAILS_INITIALIZATION',
  GET_JD_DETAILS_SUCCESS: 'GET_JD_DETAILS_SUCCESS',
  GET_JD_DETAILS_ERROR: 'GET_JD_DETAILS_ERROR',
}
const RESUME_ASSIGN_TO_BATCH = {
  RESUME_ASSIGN_TO_BATCH_INITIALIZATION:
    'RESUME_ASSIGN_TO_BATCH_INITIALIZATION',
  RESUME_ASSIGN_TO_BATCH_SUCCESS: 'RESUME_ASSIGN_TO_BATCH_SUCCESS',
  RESUME_ASSIGN_TO_BATCH_ERROR: 'RESUME_ASSIGN_TO_BATCH_ERROR',
}
const RESUME_BULK_DOWNLOAD = {
  RESUME_BULK_DOWNLOAD_INITIALIZATION: 'RESUME_BULK_DOWNLOAD_INITIALIZATION',
  RESUME_BULK_DOWNLOAD_SUCCESS: 'RESUME_BULK_DOWNLOAD_SUCCESS',
  RESUME_BULK_DOWNLOAD_ERROR: 'RESUME_BULK_DOWNLOAD_ERROR',
}

const SEND_UPDATED_RESUME_DATA = {
  SEND_UPDATED_RESUME_DATA_INITIALIZATION:
    'SEND_UPDATED_RESUME_DATA_INITIALIZATION',
}
const SEND_DUPLICATE_RESUME_DATA = {
  SEND_DUPLICATE_RESUME_DATA_INITIALIZATION:
    'SEND_DUPLICATE_RESUME_DATA_INITIALIZATION',
}

//********** RECRUITMENT AGENCY *************/
const GET_RECRUITMENT_AGENCIES_LIST = {
  GET_RECRUITMENT_AGENCIES_LIST_INITIALIZATION:
    'GET_RECRUITMENT_AGENCIES_LIST_INITIALIZATION',
  GET_RECRUITMENT_AGENCIES_LIST_SUCCESS:
    'GET_RECRUITMENT_AGENCIES_LIST_SUCCESS',
  GET_RECRUITMENT_AGENCIES_LIST_ERROR: 'GET_RECRUITMENT_AGENCIES_LIST_ERROR',
}

const GET_AGENCIES_DETAIL = {
  GET_AGENCIES_DETAIL_INITIALIZATION: 'GET_AGENCIES_DETAIL_INITIALIZATION',
  GET_AGENCIES_DETAIL_SUCCESS: 'GET_AGENCIES_DETAIL_SUCCESS',
  GET_AGENCIES_DETAIL_ERROR: 'GET_AGENCIES_DETAIL_ERROR',
}

const GET_RECRUITMENT_AGENCIES_REQUEST_LIST = {
  GET_RECRUITMENT_AGENCIES_REQUEST_LIST_INITIALIZATION:
    'GET_RECRUITMENT_AGENCIES_REQUEST_LIST_INITIALIZATION',
  GET_RECRUITMENT_AGENCIES_REQUEST_LIST_SUCCESS:
    'GET_RECRUITMENT_AGENCIES_REQUEST_LIST_SUCCESS',
  GET_RECRUITMENT_AGENCIES_REQUEST_LIST_ERROR:
    'GET_RECRUITMENT_AGENCIES_REQUEST_LIST_ERROR',
}

const GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL = {
  GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_INITIALIZATION:
    'GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_INITIALIZATION',
  GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_SUCCESS:
    'GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_SUCCESS',
  GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_ERROR:
    'GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL_ERROR',
}

const RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE = {
  RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_INITIALIZATION:
    'RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_INITIALIZATION',
  RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_SUCCESS:
    'RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_SUCCESS',
  RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_ERROR:
    'RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE_ERROR',
}

const SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST = {
  SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_INITIALIZATION:
    'SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_INITIALIZATION',
  SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_SUCCESS:
    'SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_SUCCESS',
  SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_ERROR:
    'SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST_ERROR',
}

const ACCEPT_EMAIL_INVITATION = {
  ACCEPT_EMAIL_INVITATION_INITIALIZATION:
    'ACCEPT_EMAIL_INVITATION_INITIALIZATION',
  ACCEPT_EMAIL_INVITATION_SUCCESS: 'ACCEPT_EMAIL_INVITATION_SUCCESS',
  ACCEPT_EMAIL_INVITATION_ERROR: 'ACCEPT_EMAIL_INVITATION_ERROR',
}

const GET_RECRUITMENT_JD_INVITATION = {
  GET_RECRUITMENT_JD_INVITATION_INITIALIZATION:
    'GET_RECRUITMENT_JD_INVITATION_INITIALIZATION',
  GET_RECRUITMENT_JD_INVITATION_SUCCESS:
    'GET_RECRUITMENT_JD_INVITATION_SUCCESS',
  GET_RECRUITMENT_JD_INVITATION_FAILED: 'GET_RECRUITMENT_JD_INVITATION_FAILED',
}

const GET_RECRUITMENT_ACTIVE_JD_LIST = {
  GET_RECRUITMENT_ACTIVE_JD_LIST_INITIALIZATION:
    'GET_RECRUITMENT_ACTIVE_JD_LIST_INITIALIZATION',
  GET_RECRUITMENT_ACTIVE_JD_LIST_SUCCESS:
    'GET_RECRUITMENT_ACTIVE_JD_LIST_SUCCESS',
  GET_RECRUITMENT_ACTIVE_JD_LIST_FAILED:
    'GET_RECRUITMENT_ACTIVE_JD_LIST_FAILED',
}

const GET_RECRUITMENT_SHARED_CANDIDATE_LIST = {
  GET_RECRUITMENT_SHARED_CANDIDATE_LIST_INITIALIZATION:
    'GET_RECRUITMENT_SHARED_CANDIDATE_LIST_INITIALIZATION',
  GET_RECRUITMENT_SHARED_CANDIDATE_LIST_SUCCESS:
    'GET_RECRUITMENT_SHARED_CANDIDATE_LIST_SUCCESS',
  GET_RECRUITMENT_SHARED_CANDIDATE_LIST_FAILED:
    'GET_RECRUITMENT_SHARED_CANDIDATE_LIST_FAILED',
}

const GET_AVERAGE_TIME_TO_FILL_DATA = {
  GET_AVERAGE_TIME_TO_FILL_DATA_INITIALIZATION:
    'GET_AVERAGE_TIME_TO_FILL_DATA_INITIALIZATION',
  GET_AVERAGE_TIME_TO_FILL_DATA_SUCCESS:
    'GET_AVERAGE_TIME_TO_FILL_DATA_SUCCESS',
  GET_AVERAGE_TIME_TO_FILL_DATA_FAILED: 'GET_AVERAGE_TIME_TO_FILL_DATA_FAILED',
}

const GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA = {
  GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_INITIALIZATION:
    'GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_INITIALIZATION',
  GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_SUCCESS:
    'GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_SUCCESS',
  GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_FAILED:
    'GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA_FAILED',
}

const GET_SUBMISSION_TRACK_DATA = {
  GET_SUBMISSION_TRACK_DATA_INITIALIZATION:
    'GET_SUBMISSION_TRACK_DATA_INITIALIZATION',
  GET_SUBMISSION_TRACK_DATA_SUCCESS: 'GET_SUBMISSION_TRACK_DATA_SUCCESS',
  GET_SUBMISSION_TRACK_DATA_FAILED: 'GET_SUBMISSION_TRACK_DATA_FAILED',
}

const GET_OVERALL_SUBMISSION_STATS_DATA = {
  GET_OVERALL_SUBMISSION_STATS_DATA_INITIALIZATION:
    'GET_OVERALL_SUBMISSION_STATS_DATA_INITIALIZATION',
  GET_OVERALL_SUBMISSION_STATS_DATA_SUCCESS:
    'GET_OVERALL_SUBMISSION_STATS_DATA_SUCCESS',
  GET_OVERALL_SUBMISSION_STATS_DATA_FAILED:
    'GET_OVERALL_SUBMISSION_STATS_DATA_FAILED',
}

const COMPANY = {
  COMPANY_DETAILS_REQUEST: 'COMPANY_DETAILS_REQUEST',
  COMPANY_DETAILS_SUCCESS: 'COMPANY_DETAILS_SUCCESS',
  COMPANY_DETAILS_FAILURE: 'COMPANY_DETAILS_FAILURE',
}

export {
  LOGIN,
  LOGOUT,
  CHANGE_PASSWORD,
  GET_AGENCIES_DETAIL,
  GET_RECRUITMENT_AGENCIES_LIST,
  GET_RECRUITMENT_AGENCIES_REQUEST_LIST,
  GET_RECRUITMENT_AGENCIES_REQUEST_DETAIL,
  GET_USER_DETAILS,
  GET_USERS_LIST,
  GET_RECRUITMENT_JD_INVITATION,
  GET_RECRUITMENT_ACTIVE_JD_LIST,
  GET_RECRUITMENT_SHARED_CANDIDATE_LIST,
  GET_AVERAGE_TIME_TO_FILL_DATA,
  GET_CANDIDATE_QUALITY_DISTRIBUTION_DATA,
  GET_SUBMISSION_TRACK_DATA,
  GET_OVERALL_SUBMISSION_STATS_DATA,
  GET_SKILL_SET,
  GET_SKILL_SET_LIST,
  GET_JOB_ROLE_SUBMITTED_CANDIDATE_LIST,
  SET_SKILL_SET,
  UPDATE_USER_DETAILS,
  UPDATE_USER_EMAIL_DETAILS,
  VERIFY_USER_EMAIL_DETAILS,
  GET_PRIMARY_COUNTRY_LIST_ACTION,
  GET_PRIMARY_STATE_LIST_ACTION,
  GET_PRIMARY_CITY_LIST_ACTION,
  BATCH_LIST,
  BATCH_CREATE,
  BATCH_UPDATE,
  BATCH_DELETE,
  BATCH_DETAILS,
  EXAM_LIST,
  EXAM_CREATE,
  EXAM_TYPE,
  EXAM_GRADE_LIST,
  SUBJECT_LIST,
  TOPIC_LIST,
  QUESTION_LIST,
  REASONING_TYPE_LIST,
  QUESTION_CREATE,
  QUESTION_UPDATE,
  QUESTION_DETAILS,
  QUESTION_DELETE,
  STUDENT_DATA,
  ATTEND_EXAM,
  START_EXAM,
  UPDATE_QUESTION,
  SUBMIT_EXAM,
  SEND_RECRUITMENT_AGENCIES_CONNECTION_REQUEST,
  ACCEPT_EMAIL_INVITATION,
  REPORT_QUESTION_TYPE_GET,
  REPORT_QUESTION_TYPE_POST,
  RECRUITMENT_AGENCIES_REQUEST_ACCEPT_DECLINE,
  UPDATE_EXAM,
  QUESTION_BULK_UPLOAD,
  DASHBOARD_DATA,
  ADD_EMPLOYEES_TO_BATCH,
  EXTERNAL_CANDIDATE_REGISTRATION,
  EXAM_REPORT_DATA,
  EXAM_REPORT_QUESTIONS,
  BATCH_EXAMS,
  BATCH_BULK_UPLOAD_EXTERNAL_CANDIDATES,
  BATCH_BULK_UPLOAD_EMPLOYEES,
  BATCH_MEMBERS,
  SEND_INVITE_TO_JOIN_BATCH,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  NOTIFICATION_LIST,
  NOTIFICATION_DETAILS,
  FETCH_RANDOM_USERNAME_PWD,
  FETCH_BULK_UPLOAD_DETAILS,
  CREATE_AUTOGENERATE_EXAM_QUESTIONS,
  GET_BRANCH_ACTION,
  GET_DEPARTMENT_ACTION,
  GET_EMPLOYEE_ACTION,
  ADD_EMPLOYEE_ACTION,
  EDIT_EMPLOYEE_ACTION,
  GET_ORGANIZATION_ACTION,
  EDIT_ORGANIZATION_ACTION,
  GET_ALTERNATE_COUNTRY_LIST_ACTION,
  GET_ALTERNATE_STATE_LIST_ACTION,
  GET_ALTERNATE_CITY_LIST_ACTION,
  ADD_BULK_EMPLOYEE_ACTION,
  BRANCH_LIST,
  QUESTIONNAIRE_UPLOAD,
  UPLOAD_QUESTIONNAIRE_HISTORY,
  QUESTIONNAIRE_LIST,
  BRANCH_CREATE,
  BRANCH_UPDATE,
  BRANCH_DETAILS,
  BRANCH_DELETE,
  ADD_EMPLOYEES_TO_BRANCH,
  BRANCH_MEMBERS,
  REMOVE_MEMBER_FROM_BRANCH,
  ADD_BULK_EMPLOYEE_HISTORY_ACTION,
  BULK_UPLOAD_BRANCH_MEMBERS,
  GET_EXAM_CREATE_REQUEST_ACTION,
  GET_SME_EXAM_LIST_ACTION,
  GET_EXAM_CREATE_REQUEST_COUNT_ACTION,
  GET_SME_EXAM_PERFORMANCE_ACTION,
  QUESTIONNAIRE_DETAILS,
  GET_EXAM_CREATION_DETAILS,
  SME_CREATE_EXAM_QP,
  GET_ALL_EXAM_CREATE_REQUEST_ACTION,
  GET_CORPORATE_BRANCH_TOTAL_DETAILS_ACTION,
  GET_CORPORATE_BRANCH_PERFORMANCE_ACTION,
  GET_CORPORATE_BRANCH_EXPENDITURE_ACTION,
  REGISTER_CANDIDATE_ACTION,
  QUESTIONNAIRE_DELETE,
  DELETE_UPLOAD_HISTORY,
  GET_JOB_ROLE,
  CREATE_JOB_ROLE,
  GET_JOB_ROLE_DETAILS,
  EDIT_JOB_ROLE,
  DELETE_JOB_ROLE,
  GET_BATCH_RESUMES,
  UPLOAD_BATCH_RESUME,
  UPDATE_JOB_ROLE_DEACTIVATION_SETTING,
  GET_USER_MOVEMENT_IMAGES_ACTION,
  BATCH_RESULT,
  ASSIGN_EXAM,
  SAVE_QUESTION_STATUS,
  GET_USER_MOVEMENT_IMAGES_ZIP_ACTION,
  STUDENT_DATA_DOWNLOAD_EXCEL,
  STUDENT_DATA_DOWNLOAD_QUESTION_WISE_EXCEL,
  GET_QUALIFICATION,
  GET_RESUME_DATA,
  GET_RESUME_LINK,
  GET_EXTERNAL_CANDIDATE,
  UPDATE_BATCH_CANDIDATE,
  ASSIGN_VIEW_EXAM_REPORT_PERMISSION,
  GET_QUESTION_PAPER,
  GET_EXAM_QUESTION,
  GET_EXAM_BATCH,
  GET_BATCH_INVITATION,
  ACCEPT_BATCH_INVITATION,
  RESET_STUDENT_DOWNLOAD_REPORT,
  EXAM_TYPE_WISE_SUBJECT_LIST,
  SUBJECT_WISE_TOPIC_LIST,
  RESUME_LIBRARY,
  RESUME_LIBRARY_DETAIL,
  RESUME_LIBRARY_ASSIGN_HISTORY,
  RESUME_ACTIVITY,
  GET_RESUME_FILE,
  GET_ASSIGN_BATCH_LIST,
  GET_ASSIGN_TO_BATCH_SKILL_MATCH,
  RESUME_BULK_DELETE,
  RESUME_BULK_BOOKMARK,
  GET_JD_LIST,
  RESUME_ASSIGN_TO_BATCH,
  GET_JD_DETAILS,
  PROCESS_JS_SKILL_SET,
  RESUME_BULK_DOWNLOAD,
  SEND_UPDATED_RESUME_DATA,
  SEND_DUPLICATE_RESUME_DATA,
  COMPANY,
}
